<template>
  <b-modal
    :id="'lien-notes-modal' + lien.id"
    :ref="'lien-notes-modal' + lien.id"
    modal-class="modal-fullscreen"
    centered
    no-close-on-backdrop
    scrollable
    title="Lien notes"
    size="lg"
    hide-footer
    @show="getLienNotes()"
    @hidden="resetForm()"
  >
    <VehicleDetails
      v-if="vehicle"
      :vehicle="vehicle"
      :color="vehicle.vehicleInformation.color || '----'"
    />
    <NoteRegistrationForm
      v-if="userHasPermission('liens', 'write')"
      :vehicle="vehicle"
      :refreshData="getLienNotes"
      :lien="lien"
    />
    <b-list-group v-if="notes.status == 'fetching'" class="mt-2">
      <b-list-group-item class="text-center">
        <b-spinner variant="yellow" />
      </b-list-group-item>
    </b-list-group>
    <b-list-group v-else class="mt-2 mb-2 note-list" tag="ul">
      <b-list-group-item
        v-if="notes.data && !notes.data.length"
        class="text-center"
      >
        <b>No notes to show</b>
      </b-list-group-item>

      <b-list-group-item
        v-for="(note, i) in notes.data"
        :key="i"
        class="flex-column align-items-start"
        tag="li"
      >
        <NoteCard :note="note" :refreshData="getLienNotes" />
      </b-list-group-item>
    </b-list-group>

    <!-- <template v-slot:modal-footer="{ close }">
      <b-pagination
        :value="notes.data.currentPage"
        :total-rows="notes.data.total"
        :per-page="notes.data.perPage"
        class="mt-2"
        @change="changePage($event)"
      />
      <div class="justify-content-end">
        <b-button
          variant="outline-secondary"
          class="mr-2"
          @click="() => close()"
        >
          Cancel
        </b-button>
      </div>
    </template> -->
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import { GET_LIEN_NOTES } from "./actions";
import { superAdminMixin } from "@/modules/superAdmin/mixins.js";
import NoteRegistrationForm from "./RegistrationForm";
import VehicleDetails from "@/modules/superAdmin/components/VehicleDetails.vue";
import NoteCard from "./NoteCard.vue";
export default {
  name: "LienNotesModal",
  components: { NoteRegistrationForm, VehicleDetails, NoteCard },
  mixins: [superAdminMixin],
  props: ["lien"],
  computed: {
    ...mapState({
      vehicle: (state) => state.superAdminStore.vehicle,
      notes: (state) => state.superAdminStore.componentStore.liens.notes.notes,
    }),
  },
  methods: {
    resetForm() {
      console.log("Reset form");
    },
    changePage(page) {
      this.$store.commit(GET_LIEN_NOTES, {
        fields: { page },
      });
      this.getNotes();
    },
    getLienNotes() {
      this.$store.dispatch(GET_LIEN_NOTES, {
        id: this.lien.id,
      });
    },
  },
};
</script>

<style scoped>
.resize-none {
  resize: none;
}
.note-list {
  max-height: 500px;
  overflow-y: auto;
}
</style>
